import React, { Fragment, Component } from 'react'
import {
    Container,
    Row, Col,
    CardBody, Card, CardTitle, CardSubtitle,
    Button,
    Input,
    Label,
    FormGroup, CustomInput
} from "reactstrap"
import { ConfirmAlert } from '../../../../helpers/ui/alert'
import { AvForm, AvGroup, AvInput, AvField, AvCheckboxGroup, AvCheckbox } from "availity-reactstrap-validation"

import { Link, useHistory, Redirect } from "react-router-dom"

import apiResponse from '../../../../services/apiResponse'
import CustomSelect from '../../../../helpers/ui/CustomSelect'

import CreateBloc from './Blocs/CreateBloc'
import InternalInputComponent from './Components/InternalInputComponent'
import ExternalInputComponent from './Components/ExternalInputComponent'


class IndexView extends Component {

    createBloc = new CreateBloc();

    constructor(props) {
        super(props)
        this.state = {
            dataForm: {},
            optionInputType: [
                { label: "INTERNAL", value: 'f3dd847a-ed83-4539-9a16-7df9048cd42b' },
                { label: "EXTERNAL", value: '8026d8cd-8ac2-4706-9ee7-124372d900f0' }
            ],
            selectedInputType: ""
        }
    }

    reformatOptions = (raw, label, value) => {
        return raw.map(function(data) {
          var newObj = {};
          newObj["label"] = data[label];
          newObj["value"] = data[value];
      
          return newObj;
        });
    };

    handleInputType = (v) => {
        this.setState({ selectedInputType: v.value })
    }

    componentDidMount() {
        // get data birth country
        this.createBloc.employeeCategoriesChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    if(result.data.status) {
                        let response = result.data.response
                        //console.log(response)

                        this.setState({
                            optionInputType: this.reformatOptions(
                                response.result, 
                                'employee_categories_name',
                                'employee_categories_uuid'
                            )
                        })
                    }
                    break
                case apiResponse.ERROR:
                    
                    break
                default:
                    break
            }
        })
        this.createBloc.fetchEmployeeCategories({
          is_parent : 1
        })
    }

    componentWillUnmount(){
        this.createBloc.employeeCategoriesChannel?.unsubscribe()
    }

    render() {
        return (
            <Fragment>
                <Container fluid>
                    <Row>
                        <Col className="col-12">
                            <Card>
                                <CardBody>
                                    <CardTitle>Tambah Pegawai (Internal / External)</CardTitle>
                                    <CardSubtitle className="mb-3">
                                        Setiap isian yang bertanda (<span className="text-danger">*</span>) adalah wajib diisi.
                                    </CardSubtitle>
                                    <hr />

                                    <Row className="mb-3 x">
                                        <label
                                            htmlFor="tempat_lahir"
                                            className="col-md-3 col-form-label"
                                        >
                                        Kategori Input Pegawai <span className="text-danger">*</span>
                                        </label>
                                        <Col md="5">
                                            <CustomSelect 
                                                name="employee_input_type"
                                                errorMessage="Pilih Kategori Input Pegawai"
                                                onChange={this.handleInputType}
                                                options={this.state.optionInputType} 
                                                // validate={{ required: { value: true } }}
                                                placeholder="Pilih Kategori Input Pegawai"
                                                // defaultValue={this.state.birthSelectedNational}
                                                isAvForm={false}
                                            />
                                        </Col>
                                    </Row>

                                </CardBody>
                            </Card>
                        </Col>
                    </Row>

                    {
                        this.state.selectedInputType == 'f3dd847a-ed83-4539-9a16-7df9048cd42b' && <InternalInputComponent categoryUuid={this.state.selectedInputType}/> 
                    }
                    {
                        this.state.selectedInputType == '8026d8cd-8ac2-4706-9ee7-124372d900f0' && <ExternalInputComponent categoryUuid={this.state.selectedInputType}/> 
                    }

                </Container>
                <ConfirmAlert
                    confirmTitle="Konfirmasi!"
                    confirmInfo="Apakah anda yakin akan menyimpan data ini?"

                    loadingTitle="Mengirim data..."
                    loadingInfo="Tunggu beberapa saat"

                    successTitle="Berhasil!"
                    successInfo="Data berhasil disimpan"

                    failedTitle="Gagal!"
                    failedInfo="Data gagal disimpan"

                    showConfirm={this.state.confirm}
                    showLoading={this.state.loading}
                    showSuccess={this.state.success}
                    showFailed={this.state.failed}

                    response={this.confirmResponse}
                />
                { this.state.redirect ?
                    <Redirect to='/kepegawaian/home.html'/>
                : null }
            </Fragment>
        )
    }

}

export default IndexView